module.exports = __webpack_public_path__ + "static/img/052挂画.17b9a98.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/052挂画.jpg
// module id = /T2o
// module chunks = 0